export const isCourserianEmail = (email: string | null | undefined): boolean => {
  if (!email) {
    return false;
  }

  const emailDomain = email.split('@')[1];
  return emailDomain === 'coursera.org' || emailDomain === 'cloud.coursera.org';
};
